var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "base-info",
    class: _vm.client ? "base-info-client" : ""
  }, [_c("div", {
    staticClass: "logo-wrap"
  }, [_c("img", {
    staticClass: "logo",
    attrs: {
      src: require("@/assets/images/live/logo@3x.png")
    }
  }), _c("div", {
    staticClass: "label-wrap"
  }, [_c("div", {
    staticClass: "label"
  }, [_vm._v("红网·时刻新闻")]), _vm.data.starNum != 0 ? _c("div", {
    staticClass: "fav-wrap"
  }, [_vm._v(_vm._s(_vm.data.starNum) + " 本场点赞")]) : _vm._e()])]), _c("div", {
    staticClass: "right"
  }, [_vm.data.alwaysShow && _vm.data.onlineNum ? _c("div", {
    staticClass: "count-wrap"
  }, [_c("img", {
    staticClass: "play",
    attrs: {
      src: require("@/assets/images/live/icon_live@3x.png")
    }
  }), _c("span", [_vm._v(_vm._s(_vm.data.onlineNum) + " 播放")])]) : _vm._e(), _vm.client ? _c("div", {
    staticClass: "close-wrap",
    on: {
      click: _vm.close
    }
  }, [_c("img", {
    staticClass: "close",
    attrs: {
      src: require("@/assets/images/live/btn_live_close_windows_normal@2x.png")
    }
  })]) : _vm._e()])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };